"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const deleteOutcomingOrderById_1 = __importDefault(require("./deleteOutcomingOrderById"));
const getNextOutcomingOrderNumber_1 = __importDefault(require("./getNextOutcomingOrderNumber"));
const getOutcomingOrderById_1 = __importDefault(require("./getOutcomingOrderById"));
const postOutcomingOrder_1 = __importDefault(require("./postOutcomingOrder"));
const postIncomingOrderMatchQuery_1 = __importDefault(require("./postIncomingOrderMatchQuery"));
const putOutcomingOrderById_1 = __importDefault(require("./putOutcomingOrderById"));
// import deleteOutcomingOrderCommentary from "./deleteOutcomingOrderCommentary";
// import getOutcomingOrderActivity from "./getOutcomingOrderActivity";
// import getOutcomingOrderDuplicate from "./getOutcomingOrderDuplicate";
// import postOutcomingOrderCommentary from "./postOutcomingOrderCommentary";
// import postOutcomingOrderMatchQuery from "./postOutcomingOrderMatchQuery";
// import postOutcomingOrderPayment from "./postOutcomingOrderPayment";
// import postOutcomingOrderBoardMatchQuery from "./postOutcomingOrderBoardMatchQuery";
// import postOutcomingOrderWaypointDriveThrough
//   from "./postOutcomingOrderWaypointDriveThrough";
// import deleteOutcomingOrderWaypointDriveThrough
//   from "./deleteOutcomingOrderWaypointDriveThrough";
// import putOutcomingOrderWaypointDriveThrough
//   from "./putOutcomingOrderWaypointDriveThrough";
// import putOutcomingOrderCommentary from "./putOutcomingOrderCommentary";
const createOutcomingOrderClient = (axios) => ({
    deleteOutcomingOrderById: ({ outcomingOrderId }) => deleteOutcomingOrderById_1.default({
        axios,
        outcomingOrderId
    }),
    getNextOutcomingOrderNumber: () => getNextOutcomingOrderNumber_1.default({ axios }),
    getOutcomingOrderById: ({ outcomingOrderId }) => getOutcomingOrderById_1.default({
        axios,
        outcomingOrderId
    }),
    postOutcomingOrderMatchQuery: ({ query }) => postIncomingOrderMatchQuery_1.default({ axios, query }),
    postOutcomingOrder: ({ outcomingOrder }) => postOutcomingOrder_1.default({ axios, outcomingOrder }),
    putOutcomingOrderById: ({ outcomingOrderId, outcomingOrder }) => putOutcomingOrderById_1.default({ axios, outcomingOrderId, outcomingOrder })
    // deleteOutcomingOrderCommentary: ({
    //   outcomingOrderId,
    //   commentaryId
    // }: {
    //   outcomingOrderId: number,
    //   commentaryId: number
    // }) => deleteOutcomingOrderCommentary({
    //   axios,
    //   outcomingOrderId,
    //   commentaryId
    // }),
    //
    //
    // getOutcomingOrderActivity: ({ outcomingOrderId }: { outcomingOrderId: number }) => (
    //   getOutcomingOrderActivity({ axios, outcomingOrderId })
    // ),
    //
    // getOutcomingOrderDuplicate: ({
    //   orderSerialNumber
    // }: {
    //   orderSerialNumber: string
    // }) => (
    //   getOutcomingOrderDuplicate({ axios, orderSerialNumber })
    // ),
    //
    // postOutcomingOrderCommentary: ({
    //   outcomingOrderId,
    //   commentary
    // }: {
    //   outcomingOrderId: number,
    //   commentary: CommentaryForm
    // }) => postOutcomingOrderCommentary({ axios, outcomingOrderId, commentary }),
    //
    // postOutcomingOrderMatchQuery: ({
    //   query
    // }: {
    //   query: OutcomingOrderMatchQuery
    // }) => postOutcomingOrderMatchQuery({ axios, query }),
    //
    // postOutcomingOrderBoardMatchQuery: ({
    //   query
    // }: {
    //   query: OutcomingOrderBoardMatchQuery
    // }) => postOutcomingOrderBoardMatchQuery({ axios, query }),
    //
    // postOutcomingOrderPayment: ({
    //   outcomingOrderId,
    //   payment
    // }: {
    //   outcomingOrderId: number,
    //   payment: OutcomingOrderPaymentForm
    // }) => postOutcomingOrderPayment({ axios, outcomingOrderId, payment }),
    //
    // postOutcomingOrderWaypointDriveThrough: ({
    //   outcomingOrderId,
    //   waypointId
    // }: {
    //   outcomingOrderId: number,
    //   waypointId: number
    // }) => postOutcomingOrderWaypointDriveThrough({
    //   axios,
    //   outcomingOrderId,
    //   waypointId
    // }),
    //
    // putOutcomingOrderCommentary: ({
    //   outcomingOrderId,
    //   commentaryId,
    //   commentary
    // }: {
    //   outcomingOrderId: number,
    //   commentaryId: number,
    //   commentary: CommentaryForm
    // }) => putOutcomingOrderCommentary({
    //   axios,
    //   outcomingOrderId,
    //   commentaryId,
    //   commentary
    // }),
    //
    // deleteOutcomingOrderWaypointDriveThrough: ({
    //   outcomingOrderId,
    //   waypointId
    // }: {
    //   outcomingOrderId: number,
    //   waypointId: number
    // }) => deleteOutcomingOrderWaypointDriveThrough({
    //   axios,
    //   outcomingOrderId,
    //   waypointId
    // }),
    //
    // putOutcomingOrderWaypointDriveThrough: ({
    //   outcomingOrderId,
    //   waypointId,
    //   drivenThroughAt
    // }: {
    //   outcomingOrderId: number,
    //   waypointId: number,
    //   drivenThroughAt: Date
    // }) => putOutcomingOrderWaypointDriveThrough({
    //   axios,
    //   outcomingOrderId,
    //   waypointId,
    //   drivenThroughAt
    // })
});
exports.default = createOutcomingOrderClient;
